module.exports = ".crop {\n  overflow: hidden; }\n\ndiv {\n  cursor: pointer; }\n"